import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvGroup} from 'availity-reactstrap-validation';
import PropTypes from 'prop-types';
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import ProductService from "../../shared/service/ProductService";
import {STOCK_EVENT, STOCK_EVENT_ADD_REASON, STOCK_EVENT_DROP_REASON} from "../../shared/utils/Constants";
import '../../shared/styles/SettingsPage.css';


const defaultProduct = {
    id: '',
    name: '',
    status: 'ACTIVE',
    barcode: '',
    minStock: null,
    maxStock: null,
    currentStock: null,
    stockOperation: '',
    stockOperationReason: '',
};

export default class StockSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            product: Object.assign({}, defaultProduct),
            productDetailsSaveButtonRender: true,
        }
        this.productService = new ProductService();
    }

    componentDidMount() {

    }

    clearData = () => {
        this.setState({
            product: Object.assign({}, defaultProduct),
        });
    }

    setData = (data) => {
        this.setState({
            product: Object.assign({}, data),
        });
    }

    renderStockReasonField() {
        if (this.state.product.stockOperation === "ADD_STOCK") {
            return (
                <div className="settings-page__filter-field">
                    <AvGroup>
                        <Label for="stock-reason">
                            <Translate contentKey="producttradingName">Stock Operation Reason</Translate>
                        </Label>
                        <AvField
                            id="stock-reason"
                            type="select"
                            className="form-control"
                            name="stockEventReason"
                            disabled={!this.state.productDetailsSaveButtonRender}
                            value={this.state.product.stockEventReason}
                            onChange={this.__handleChange}>
                            {STOCK_EVENT_ADD_REASON.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>))}
                        </AvField>
                    </AvGroup>
                </div>
            );
        }
        if (this.state.product.stockOperation === "DROP_STOCK") {
            return (
                <div className="settings-page__filter-field">
                    <AvGroup>
                        <Label for="stock-reason">
                            <Translate contentKey="producttradingName">Stock Operation Reason</Translate>
                        </Label>
                        <AvField
                            id="stock-reason"
                            type="select"
                            className="form-control"
                            name="stockEventReason"
                            disabled={!this.state.productDetailsSaveButtonRender}
                            value={this.state.product.stockEventReason}
                            onChange={this.__handleChange}>
                            {STOCK_EVENT_DROP_REASON.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>))}
                        </AvField>
                    </AvGroup>
                </div>
            );
        }
        return null;
    }

    render() {
        return (
            <div className="settings-page settings-page--dialog">
                <h2 className="settings-page__section-title">Add/Drop Stock</h2>

                <div className="settings-page__filter settings-page__filter--form">
                    <div className="settings-page__filter-row settings-page__filter-row--cols-3 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="stock-barcode">
                                    <Translate contentKey="producttradingName">Barcode</Translate>
                                </Label>
                                <AvField
                                    id="stock-barcode"
                                    type="number"
                                    className="form-control"
                                    name="barcode"
                                    disabled={true}
                                    max="99999999999999"
                                    value={this.state.product.barcode}
                                    onChange={this.__handleChange}/>
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="stock-name">
                                    <Translate contentKey="producttradingName">Name</Translate>
                                </Label>
                                <AvField
                                    id="stock-name"
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    disabled={true}
                                    value={this.state.product.name}
                                    onChange={this.__handleChange}/>
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="stock-current">
                                    <Translate contentKey="producttradingName">Current Stock</Translate>
                                </Label>
                                <AvField
                                    id="stock-current"
                                    name="currentStock"
                                    type={"number"}
                                    disabled={true}
                                    value={this.state.product.currentStock}
                                    onChange={this.__handleChange}
                                    className="form-control"
                                />
                            </AvGroup>
                        </div>
                    </div>

                    <div className="settings-page__filter-row settings-page__filter-row--cols-4 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="stock-min">
                                    <Translate contentKey="producttradingName">Min Stock</Translate>
                                </Label>
                                <AvField
                                    id="stock-min"
                                    type={"number"}
                                    name="minStock"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    value={this.state.product.minStock}
                                    onChange={this.__handleChange}
                                    className="form-control"
                                />
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="stock-max">
                                    <Translate contentKey="producttradingName">Max Stock</Translate>
                                </Label>
                                <AvField
                                    id="stock-max"
                                    type={"number"}
                                    name="maxStock"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    value={this.state.product.maxStock}
                                    onChange={this.__handleChange}
                                    className="form-control"
                                />
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="stock-operation">
                                    <Translate contentKey="producttradingName">Stock Operation</Translate>
                                </Label>
                                <AvField
                                    id="stock-operation"
                                    type="select"
                                    className="form-control"
                                    name="stockOperation"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    value={this.state.product.stockOperation}
                                    onChange={this.__handleChange}>
                                    <option value='' key=''/>
                                    {STOCK_EVENT.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </div>
                        {this.renderStockReasonField()}
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="stock-qty">
                                    <Translate contentKey="producttradingName">Stock</Translate>
                                </Label>
                                <AvField
                                    id="stock-qty"
                                    name="stock"
                                    type={"number"}
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    value={this.state.product.stock}
                                    onChange={this.__handleChange}
                                    className="form-control"
                                />
                            </AvGroup>
                        </div>
                    </div>
                </div>

                <div className="settings-page__actions">
                    {!GeneralUtils.isNullOrEmpty(this.state.product.id) && GeneralUtils.checkPrivilege("post_product/product") && this.state.productDetailsSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.updateStock();
                        }}>
                            <Translate contentKey="entity.action.add">Save Stock</Translate>
                        </Button>
                    }
                    <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--close" onClick={() => {
                        this.props.closeDisplayDialog();
                    }}>
                        <Translate contentKey="entity.action.cancel">Close</Translate>
                    </Button>
                </div>
            </div>
        );
    }

    updateStock = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.product.id)) {
            this.productService.updateStock(this.state.product)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            product: response,
                        });
                        this.props.refreshDataTable();
                    }
                });
        }
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let product = this.state.product;
        product[e.target.name] = value;
        if (e.target.name == "stockOperation") {
            if (value == "ADD_STOCK") {
                product['stockOperationReason'] = "DELIVERY";
            } else if (value == "DROP_STOCK") {
                product['stockOperationReason'] = "EXPIRED";
            } else {
                product['stockOperationReason'] = "";
            }
        }
        this.setState({product: product});
    }
}

StockSave.propTypes = {
    order: PropTypes.object
};
